<template>
  <div class="goods">
    <div class="nav">
      <div class="w">
        <a href="javascript:;" :class="{active:sortType===1}" @click="reset()">综合排序</a>
        <a href="javascript:;" @click="sortByPrice(1)" :class="{active:sortType===2}">价格从低到高</a>
        <a href="javascript:;" @click="sortByPrice(-1)" :class="{active:sortType===3}">价格从高到低</a>
      </div>
    </div>

    <div v-loading="loading" element-loading-text="加载中..." style="min-height: 35vw;">
      <div class="img-item" v-if="!noResult">
        <!--商品-->
        <div class="goods-box w">
          <mall-goods v-for="(item,i) in goods" :key="i" :msg="item"></mall-goods>
        </div>

        <el-pagination
          v-if="!noResult&&!error"
          @current-change="handleCurrentChange"
          :page-size="pageSize"
          layout="total, prev, pager, next"
          :total="goodsTotal">
        </el-pagination>
      </div>
      <div class="no-info" v-if="noResult">
        <div class="no-data">
          <img src="/static/images/no-search.png">
          <br> 抱歉！暂时还没有商品
        </div>
      </div>
      <div class="no-info" v-if="error">
        <div class="no-data">
          <img src="/static/images/error.png">
          <br> 抱歉！出错了...
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import api from '@/api'
    import MallGoods from '@/components/mallGoods'
    import YButton from '@/components/yButton'
    import {mapGetters, mapActions} from 'vuex'
  export default {
    data () {
      return {
        error: false,
        loading: false,
        timer: null,
        sortType: 1,
        windowHeight: null,
        windowWidth: null,
        sort: '',
        currentPage: 1,
        total: 0,
        pageSize: 12,
        sortAsc:true,
        sorting:'zonghe'
      }
    },
    methods: {
      handleSizeChange (val) {
        this.pageSize = val
        this._getAllGoods()
        this.loading = true
      },
      handleCurrentChange (val) {
        this.currentPage = val
        this._getAllGoods()
        this.loading = true
      },
      async _getAllGoods () {

        let MaxResultCount =  this.pageSize
        let SkipCount = (this.currentPage - 1) * this.pageSize
        let params = {
            skipCount: SkipCount,
            maxResultCount: MaxResultCount,
            categoryId:0,
            sortAsc:this.sortAsc,
            sorting:this.sorting,
            name: ''
        }
        await this.loadGoodsList(params)
        this.loading = false
        this.searching = false
        this.$forceUpdate();
      },
      // 默认排序
      reset () {
        this.sortType = 1
        this.sort = ''
        this.sorting = 'zonghe'
        this.currentPage = 1
        //this.loading = true
        this._getAllGoods()
      },
      // 价格排序
      sortByPrice (v) {
       
        v === 1 ? this.sortType = 2 : this.sortType = 3
        this.sort = v
        this.sorting = 'price'
        this.sortAsc =  v === 1 ? true : false
        this.currentPage = 1
       // this.loading = true
        this._getAllGoods()
      },
      ...mapActions([
       'loadGoodsList',
      ])
    },
    computed: {
      ...mapGetters([
        'goods',
        'goodsTotal',
        'noResult'
      ])
    },
    created () {
        //this._getAllGoods()
    },
    mounted () {
      this.windowHeight = window.innerHeight
      this.windowWidth = window.innerWidth
      this._getAllGoods()
    },
    components: {
      MallGoods,
      YButton
    }
  }
</script>
<style lang="stylus">
  @import '../../common/stylus/common'
 

  .nav {
    height: 60px;
    line-height: 60px;
    > div {
      display: flex;
      align-items: center;
      a {
        padding: 0 15px;
        height: 100%;
        // @extend %block-center;
        font-size: 12px;
        color: #999;
        &.active {
          color: #5683EA;
        }
        &:hover {
          color: #5683EA;
        }
      }
      input {
        width 80px;
        height 30px;
        border: 1px solid #ccc;
      }
      input + input {
        margin-left: 10px;
      }
    }
    .price-interval {
      padding: 0 15px;
     // @extend %block-center;
      input[type=number] {
        border: 1px solid #ccc;
        text-align: center;
        background: none;
        border-radius: 5px;
      }
    }
  }

  .goods-box {
    > div {
      float: left;
      border: 1px solid #efefef;
    }
  }

  .no-info {
    padding: 100px 0;
    text-align: center;
    font-size: 30px;
    display: flex;
    flex-direction: column;
    .no-data{
      align-self: center;
    }
  }

  .img-item{
    display: flex;
    flex-direction: column;
  }

  .el-pagination{
    align-self: flex-end;
    margin: 3vw 10vw 2vw;
  }

  .section {
    padding-top: 8vw;
    margin-bottom: -5vw;
    width: 1218px;
    align-self: center;
  }

  .recommend {
    display: flex;
    > div {
      flex: 1;
      width: 25%;
    }
  }



</style>



// WEBPACK FOOTER //
// index.vue?37792400